/**
 * Place any jQuery/helper plugins in here.
 */
$(function () {
    /**
     * Checkbox tree for permission selecting
     */
    $('#tree :checkbox').on('click change', function (){
        if($(this).is(':checked')) {
            $(this).siblings('ul').find('input[type="checkbox"]').attr('checked', true).attr('disabled', true);
        } else {
            $(this).siblings('ul').find('input[type="checkbox"]').removeAttr('checked').removeAttr('disabled');
        }
    });

    $('#tree :checkbox').each(function () {
        if($(this).is(':checked')) {
            $(this).siblings('ul').find('input[type="checkbox"]').attr('checked', true).attr('disabled', true);
        }
    });

    /**
     * Disable submit inputs in the given form
     *
     * @param form
     */
    function disableSubmitButtons(form) {
        form.find('input[type="submit"]').attr('disabled', true);
        form.find('button[type="submit"]').attr('disabled', true);
    }

    /**
     * Enable the submit inputs in a given form
     *
     * @param form
     */
    function enableSubmitButtons(form) {
        form.find('input[type="submit"]').removeAttr('disabled');
        form.find('button[type="submit"]').removeAttr('disabled');
    }

    /**
     * Disable all submit buttons once clicked
     */
    $('form').submit(function () {
        disableSubmitButtons($(this));
        return true;
    });

    /**
     * Add a confirmation to a delete button/form
     */
    $('body').on('submit', 'form[name=delete-item]', function(e) {
        e.preventDefault();

        var message = $(this).data('message');
        var confirmButtonText = $(this).data('confirm-button-text');
        var cancelButtonText = $(this).data('cancel-button-text');

        Swal.fire({
            title: message,
            showCancelButton: true,
            confirmButtonText: confirmButtonText,
            cancelButtonText: cancelButtonText,
            icon: 'warning',
        }).then((result) => {
            if (result.value) {
                this.submit()
            } else {
                enableSubmitButtons($(this));
            }
        });
    })
        .on('submit', 'form[name=confirm-item]', function (e) {
            e.preventDefault();

            Swal.fire({
                title: 'Are you sure you want to do this?',
                showCancelButton: true,
                confirmButtonText: 'Continue',
                cancelButtonText: 'Cancel',
                icon: 'warning'
            }).then((result) => {
                if (result.value) {
                    this.submit()
                } else {
                    enableSubmitButtons($(this));
                }
            });
        })
        .on('click', 'a[name=confirm-item]', function (e) {
        /**
         * Add an 'are you sure' pop-up to any button/link
         */
        e.preventDefault();

        Swal.fire({
            title: 'Are you sure you want to do this?',
            showCancelButton: true,
            confirmButtonText: 'Continue',
            cancelButtonText: 'Cancel',
            icon: 'info',
        }).then((result) => {
            result.value && window.location.assign($(this).attr('href'));
        });
    });

    // Remember tab on page load
    $('a[data-toggle="tab"], a[data-toggle="pill"]').on('shown.bs.tab', function (e) {
        let hash = $(e.target).attr('href');
        history.pushState ? history.pushState(null, null, hash) : location.hash = hash;
    });

    let hash = window.location.hash;
    if (hash) {
        $('.nav-link[href="'+hash+'"]').tab('show');
    }

    // Enable tooltips everywhere
    $("body").tooltip({ selector: '[data-toggle=tooltip]' });

    //Ajax
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    $(document).on("click", ".c-sidebar-minimizer", function() {
        if(!$("#sidebar").hasClass("c-sidebar-minimized")) {
            $("#sidebar").addClass("c-sidebar-minimized");
            $("#sidebar").find(".c-sidebar-nav").removeClass("ps");
            $.get(window.location.origin+"/settings/layout/menu-minimized/1");
        } else {
            $("#sidebar").removeClass("c-sidebar-minimized");
            $.get(window.location.origin+"/settings/layout/menu-minimized/0");
        }
    });

    $(document).on("click", ".c-header-toggler", function() {

        //if mobile
        if(window.innerWidth < 992) {
            if(!$("#sidebar").hasClass("c-sidebar-show")) {
                $("#sidebar").addClass("c-sidebar-show");
                //spawn backdrop
                var backdrop = document.createElement("div");
                backdrop.setAttribute("class", "c-sidebar-backdrop c-fade c-show");
                document.body.appendChild(backdrop);

            } else {
                $("#sidebar").removeClass("c-sidebar-show");
                //remove backdrop
                $(".c-sidebar-backdrop").remove();
            }
        } else {
            if(!$("#sidebar").hasClass("c-sidebar-lg-show")) {
                $("#sidebar").addClass("c-sidebar-lg-show");
                $.get(window.location.origin+"/settings/layout/menu-hidden/0");
            } else {
                $("#sidebar").removeClass("c-sidebar-lg-show");
                $.get(window.location.origin+"/settings/layout/menu-hidden/1");
            }
        }
    });

    //on backdrop click remove sidebar
    $(document).on("click", ".c-sidebar-backdrop", function() {
        $("#sidebar").removeClass("c-sidebar-show");
        $(".c-sidebar-backdrop").remove();
    });

    $(document).on("click", "#header-tooltip", function() {
        if($("body").hasClass("c-dark-theme")) {
            $("body").removeClass("c-dark-theme");
            $.get(window.location.origin+"/settings/layout/layout/0");
        } else {
            $("body").addClass("c-dark-theme");
            $.get(window.location.origin+"/settings/layout/layout/1");
        }
    });
});
